import { Box, styled } from '@withjoy/joykit';

export const StyledInputWrapper = styled(Box)<{ $focusColor?: string }>`
  *:focus-within::after {
    /* !important required: JoyKit's useFocusBoxStyles generates the focus ring CSS at the same specificity */
    box-shadow: ${p => (p.$focusColor ? `0 0 0 2px ${p.$focusColor}` : 'none')} !important;
  }
`;
